export default __webpack_public_path__ + "static/media/img_2.e7664017.jpg";